import Bell from 'lucide-react-native/icons/bell';
import Drama from 'lucide-react-native/icons/drama';
import Ellipsis from 'lucide-react-native/icons/ellipsis';
import Film from 'lucide-react-native/icons/film';
import Heart from 'lucide-react-native/icons/heart';
import Map from 'lucide-react-native/icons/map';
import Music from 'lucide-react-native/icons/music';
import Palette from 'lucide-react-native/icons/palette';
import PartyPopper from 'lucide-react-native/icons/party-popper';
import Tent from 'lucide-react-native/icons/tent';
import Ticket from 'lucide-react-native/icons/ticket';
import Trophy from 'lucide-react-native/icons/trophy';
import UtensilsCrossed from 'lucide-react-native/icons/utensils-crossed';
import Users from 'lucide-react-native/icons/users';
import type { LucideIcon } from 'lucide-react-native';

export type City = {
  id: string;
  name: string;
  /** Small (96x96) thumbnail — the city chips on /events, /tours and /boats. */
  image: number;
  /** Full-bleed 1024x1024 photo for the city landing page hero. */
  heroImage: number;
  /** 750x750 variant of heroImage for narrower viewports (web srcSet only). */
  heroImageSm: number;
  /**
   * 440x280 crop of heroImage for the /cities hub cards (220x140 CSS px, so
   * this is the 2x asset). The 96px chip thumbnail was being upscaled ~4.5x.
   */
  cardImage: number;
  /** 220x140 (1x) variant of cardImage — web srcSet only. */
  cardImageSm: number;
};

export const cities: City[] = [
  {
    id: 'nice',
    name: 'Nice',
    image: require('@/assets/images/riviera/city-nice.webp'),
    heroImage: require('@/assets/images/riviera/city-nice-hero.webp'),
    heroImageSm: require('@/assets/images/riviera/city-nice-hero-750.webp'),
    cardImage: require('@/assets/images/riviera/city-nice-card.webp'),
    cardImageSm: require('@/assets/images/riviera/city-nice-card-220.webp'),
  },
  {
    id: 'cannes',
    name: 'Cannes',
    image: require('@/assets/images/riviera/city-cannes.webp'),
    heroImage: require('@/assets/images/riviera/city-cannes-hero.webp'),
    heroImageSm: require('@/assets/images/riviera/city-cannes-hero-750.webp'),
    cardImage: require('@/assets/images/riviera/city-cannes-card.webp'),
    cardImageSm: require('@/assets/images/riviera/city-cannes-card-220.webp'),
  },
  {
    id: 'monaco',
    name: 'Monaco',
    image: require('@/assets/images/riviera/city-monaco.webp'),
    heroImage: require('@/assets/images/riviera/city-monaco-hero.webp'),
    heroImageSm: require('@/assets/images/riviera/city-monaco-hero-750.webp'),
    cardImage: require('@/assets/images/riviera/city-monaco-card.webp'),
    cardImageSm: require('@/assets/images/riviera/city-monaco-card-220.webp'),
  },
  {
    id: 'antibes',
    name: 'Antibes',
    image: require('@/assets/images/riviera/city-antibes.webp'),
    heroImage: require('@/assets/images/riviera/city-antibes-hero.webp'),
    heroImageSm: require('@/assets/images/riviera/city-antibes-hero-750.webp'),
    cardImage: require('@/assets/images/riviera/city-antibes-card.webp'),
    cardImageSm: require('@/assets/images/riviera/city-antibes-card-220.webp'),
  },
  {
    id: 'sttropez',
    name: 'Saint-Tropez',
    image: require('@/assets/images/riviera/city-sttropez.webp'),
    heroImage: require('@/assets/images/riviera/city-sttropez-hero.webp'),
    heroImageSm: require('@/assets/images/riviera/city-sttropez-hero-750.webp'),
    cardImage: require('@/assets/images/riviera/city-sttropez-card.webp'),
    cardImageSm: require('@/assets/images/riviera/city-sttropez-card-220.webp'),
  },
  {
    id: 'menton',
    name: 'Menton',
    image: require('@/assets/images/riviera/city-menton.webp'),
    heroImage: require('@/assets/images/riviera/city-menton-hero.webp'),
    heroImageSm: require('@/assets/images/riviera/city-menton-hero-750.webp'),
    cardImage: require('@/assets/images/riviera/city-menton-card.webp'),
    cardImageSm: require('@/assets/images/riviera/city-menton-card-220.webp'),
  },
  {
    id: 'villefranche',
    name: 'Villefranche-sur-Mer',
    image: require('@/assets/images/riviera/city-villefranche.webp'),
    heroImage: require('@/assets/images/riviera/city-villefranche-hero.webp'),
    heroImageSm: require('@/assets/images/riviera/city-villefranche-hero-750.webp'),
    cardImage: require('@/assets/images/riviera/city-villefranche-card.webp'),
    cardImageSm: require('@/assets/images/riviera/city-villefranche-card-220.webp'),
  },
];

// Display text for these lives in the i18n resources, keyed by `id`
// (dateFilters.<id>, categories.<id>, categoryNouns.<id>, features.<id>.*).
export type DateFilter = { id: string };

export const dateFilters: DateFilter[] = [
  { id: 'alltime' },
  { id: 'today' },
  { id: 'tomorrow' },
  { id: 'weekend' },
  { id: 'custom' },
];

export type Category = { id: string; icon: LucideIcon };

export const categories: Category[] = [
  { id: 'concerts', icon: Music },
  { id: 'theatre', icon: Drama },
  { id: 'exhibitions', icon: Palette },
  { id: 'parties', icon: PartyPopper },
  { id: 'gastronomy', icon: UtensilsCrossed },
  { id: 'festivals', icon: Tent },
  { id: 'sport', icon: Trophy },
  { id: 'family', icon: Users },
  { id: 'cinema', icon: Film },
  { id: 'other', icon: Ellipsis },
];

export type Feature = { id: string; icon: LucideIcon };

export const features: Feature[] = [
  { id: 'notifications', icon: Bell },
  { id: 'favorites', icon: Heart },
  { id: 'map', icon: Map },
  { id: 'tickets', icon: Ticket },
];
